<template>
    <div class="UserAgreement xi">
        <nh-com></nh-com>
        <div class="banner">
            <div class="banner-text">
                <h3>会员在线服务协议</h3>
                <!-- <p>Ge Ren XI YI</p> -->
            </div>
        </div>
        <div class="agreement-box">
            <div class="agreement-tit">
                <h3>会员在线服务协议</h3>
            </div>
            <div class="agreement-content">
                 <div class="disclaimer-container">
                        <div class="disclaimer-content">
                        <p>欢迎您使用千越医助手平台，对于您对本平台的支持与理解，致以最诚挚的感谢！</p>

                        <h3 class="title">一、词汇定义</h3>
                        <p>河南千越医疗科技有限公司：指基于本协议规定，为用户提供所有服务的运营方，以下统称“我司”或本公司。</p>
                        <p>千越医助手平台：指包括千越医助手网站、千越医助手移动客户端及其他现有或将来推出的其他在线服务的平台，以下统称“服务平台”或“本平台”。</p>
                        <p>用户：指享受我司提供的所有服务的使用者的单位或个人，以下简称为“您”或者用户</p>
                        <p>会员在线服务协议：以下简称“本协议”。</p>
                        
                        <h3 class="title">二、协议说明</h3>
                        <p>本协议是为了约束您与我司之间关于使用本平台所订立的各项规定。</p>
			            <p>您应当同意本协议的全部条款，并严格按照本协议所有条款，合理合法使用本平台。</p>

                        <h3 class="title">三、协议效期</h3>
                        <p>当您选择使用本平台的服务，即表示您已充分阅读、理解并接受本协议的全部内容。您的使用行为将被认为是对本协议全部条款无保留的接受和遵守。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止使用。如需与我司联系的话，可拨打我司客服电话：0395-3393819。</p>
			            <p>【重要提醒】在您同意本协议之前，请务必认真阅读本协议，充分理解各条款内容。如您对协议有任何疑问，可向我司客服咨询。如您未满18周岁，请在监护人的陪同下阅读本协议。</p>
                        
                        
                        <h3 class="title">四、服务内容</h3>
                        <p>1、平台提供的服务</p>
                        <p>(1)确保用户全天24小时可以正常使用本平台；</p>
                        <p>(2)保证用户可以随时联系平台客服，并及时处理用户的问题，解决用户疑问等</p>
                        <p>(3)定期或不定期更新、升级本平台功能；</p>
                        <p>(4)不断优化服务内容，为用户提供完善的服务；</p>
                        <p>(5)保障用户的信息安全，包含但不限于用户账号、密码、手机号、照片、各项记录数据等内容</p>
                        <p >2、服务时长</p>
                        <p>在用户注册成功后，服务开始计时，根据您购买的本平台的版本不同，服务时长、服务内容均不同，版本到期后自动结束</p>
                        <p>如果您在版本有效期内，又购买了其他版本，则将在原来的服务期限基础上，增加相应的服务时长和服务内容。</p>
                        <p >3、服务的变更、中断或终止</p>
                        <p>(1)鉴于网络服务的特殊性，我司不保证网络服务不会中断，也不保证服务的及时性、安全性、准确性。用户同意我司有权不经事先通知，随时变更、中断或终止部分或全部的服务，也包括收费服务。无论因任何原因发生服务中断、不及时、不安全、不准确的情况，我司均不承担任何责任。</p>
                        <p>(2)我司需要定期或不定期地对提供服务的平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，我司无需为此承担任何责任，同时我司保留维修、保养、升级、更新或其它目的暂停本平台，或暂停提供服务的权利。</p>
                        <p>(3)用户违规使用本平台的行为，包含但不限于以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或使用本平台，我司将终止向您提供服务，且不会给用户退款。</p>
                        <p>(4)如发生下列任何一种情形，我司有权随时中断或终止向用户提供服务，并无需对用户或任何第三方承担任何责任：</p>
                        <p>●用户提供的个人资料、信息不真实；</p>
                        <p>●用户违反本协议中规定的条款及规则；</p>
                        <p>●因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
                        <p>●因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
                        <p>●因常规或紧急设备或平台维护、故障、网络信息与数据安全等因素。</p>
                        <p>(5)根据国家相应的法律法规规定变化以及平台运营需要，我司有权对本协议进行不定期制定、修改相关服务规则。暂停、取消和修改本协议部分条款，修改后的条款一旦在本平台显示即生效，并代替原来的协议，您应及时关注本协议的各种服务变更，如您继续使用平台，即视为同意本协议的所有更改内容。</p>
                        
                        <div class="footer-space"></div>
                        </div>
                    </div>
            </div>
        </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>
    import ftCom from '../../components/footer';
    import nhCom from "../../components/navheader";
    // import rtBar from "../../components/right";
    export default {
        name: "UserAgreement",
        components: {
            ftCom,
            nhCom,
            // rtBar
        },
    }
</script>

<style scoped>
    .UserAgreement{
        background: #f4f4f4;
    }
    .xi .banner{
        height: 116px;
        background: url("../../assets/img/jbk_banner.png")center no-repeat;
    }
    .banner-text{
        width: 1200px;
        margin: 0 auto;
    }
    .banner-text h3{
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }
    .banner-text p{
        font-size: 18px;
        color: #ffffff;
    }
    .agreement-box {
        margin: 30px auto;
        width: 1200px;
        padding: 20px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #e5e5e5;
    }
    .agreement-tit{
        padding: 10px 0 20px;
        border-bottom: 1px solid #e5e5e5;
    }
    .agreement-tit h3{
        font-size: 20px;
        color: #333333;
        text-align: center;
        font-weight: bold;
    }
    .agreement-content{
        padding: 25px 0;
    }
    .agreement-content p{
        text-indent: 28px;
        line-height: 2;
    }
    .agreement-content p.s-p{
        text-indent: 42px;
    }
    .agreement-content h4{
        text-indent: 28px;
        line-height: 1.7;
        padding: 15px 0;
    }
    .disclaimer-container {
  /* background-color: #f5f5f5; */
  min-height: 100vh;
  padding: 20px 0;
}

.disclaimer-content {
  background-color: #fff;
  padding: 24px;
  margin: 0 auto;
  /* max-width: 800px; */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
  color: #666;
  /* line-height: 1.6; */
}

.disclaimer-content p {
  margin: 12px 0;
  text-indent: 2em;
  text-align: justify;
}

.title {
  font-weight: 800;
  padding: 20px 0 10px 0;
  color: #333;
  border-bottom: 1px solid #eee;
  margin: 24px 0 16px 0;
}

.footer-space {
  width: 100%;
  height: 50px;
}
</style>

